import { IRootState } from '../../../store'
import { ITimelineState } from '../store/timeline.types'

export const getPatientTimelineSelector = (state: IRootState): ITimelineState => state.timeline
